<template>
  <div class="dashboard__calculator">
    <div>
      <div class="row m-0">
        <div class="col-md p-0">
          <p class="fontstyle__title--sectionwhite" >Storage Calculator</p>
          <p class="dashboard__calculator--subtitle" >Estimate your shipment storage now!</p>
        </div>
      </div>
      <router-link :to="name='StorageCalculator'" tag="div"
      class="d-flex align-items-start justify-content-start" style="padding-top: 12px">
        <button class="button__whitesmall" type="button" name="button">Calculate Now
          <img width="15px" src="@/assets/image/icon/Vector.svg" alt="" class="ml-2">
        </button>
      </router-link>
    </div>
    <div class="dashboard__calculator--image d-flex justify-content-end">
      <img width="130px" src="@/assets/image/icon/Quotation.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'StorageCalculator'
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/StorageCalculator.vue